import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateAddressDetails = () => {
  const history = useHistory();
  const { id } = useParams();

  const capitalize = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const stateData = {
    "Tamil Nadu": {
      districts: [
        "ariyalur",
        "chengalpattu",
        "chennai",
        "coimbatore",
        "cuddalore",
        "dharmapuri",
        "dindigul",
        "erode",
        "kallakurichi",
        "kanchipuram",
        "kanyakumari",
        "karur",
        "krishnagiri",
        "madurai",
        "mayiladuthurai",
        "nagapattinam",
        "nilgiris",
        "namakkal",
        "perambalur",
        "pudukkottai",
        "ramanathapuram",
        "ranipet",
        "salem",
        "sivaganga",
        "tenkasi",
        "tiruppur",
        "tiruchirappalli",
        "theni",
        "tirunelveli",
        "thanjavur",
        "thoothukudi",
        "tirupattur",
        "tiruvallur",
        "tiruvarur",
        "tiruvannamalai",
        "vellore",
        "viluppuram",
        "virudhunagar",
      ].map(capitalize),
    },
  };

  const talukData = {
    Ariyalur: ["Ariyalur", "Udayarpalayam", "Sendurai"],
    Chengalpattu: [
      "Chengalpattu",
      "Thiruporur",
      "Tirukalukundram",
      "Madurantakam",
      "Pallavaram",
      "Tambaram",
    ],
    Chennai: [
      "Fort-Tondiarpet",
      "Purasawalkam",
      "Egmore",
      "Mylapore",
      "Guindy",
      "Madhavaram",
      "Ayanavaram",
    ],
    Coimbatore: [
      "Coimbatore North",
      "Coimbatore South",
      "Sulur",
      "Mettupalayam",
      "Annur",
      "Pollachi",
      "Kinathukadavu",
      "Valparai",
    ],
    Cuddalore: [
      "Cuddalore",
      "Panruti",
      "Chidambaram",
      "Kattumannarkoil",
      "Bhuvanagiri",
      "Virudhachalam",
      "Tittakudi",
    ],
    Dharmapuri: ["Dharmapuri", "Harur", "Pappireddipatti", "Pennagaram", "Palacode"],
    Dindigul: [
      "Dindigul",
      "Natham",
      "Athoor",
      "Palani",
      "Oddanchatram",
      "Vedasandur",
      "Kodaikanal",
    ],
    Erode: [
      "Erode",
      "Perundurai",
      "Modakurichi",
      "Bhavani",
      "Gobichettipalayam",
      "Sathyamangalam",
    ],
    Kallakurichi: [
      "Kallakurichi",
      "Sankarapuram",
      "Chinnasalem",
      "Tirukoilur",
      "Ulundurpet",
    ],
    Kanchipuram: [
      "Kanchipuram",
      "Uthiramerur",
      "Walajabad",
      "Sriperumbudur",
      "Alandur",
    ],
    Kanyakumari: [
      "Agastheeswaram",
      "Thovalai",
      "Kalkulam",
      "Vilavancode",
      "Killiyoor",
    ],
    Karur: ["Karur", "Aravakurichi", "Kadavur", "Krishnarayapuram", "Kulithalai"],
    Krishnagiri: [
      "Krishnagiri",
      "Hosur",
      "Denkanikottai",
      "Pochampalli",
      "Uthangarai",
    ],
    Madurai: [
      "Madurai North",
      "Madurai South",
      "Melur",
      "Thirumangalam",
      "Usilampatti",
      "Vadipatti",
    ],
    Mayiladuthurai: [
      "Mayiladuthurai",
      "Sirkazhi",
      "Kuthalam",
      "Tharangambadi",
    ],
    Nagapattinam: [
      "Nagapattinam",
      "Kilvelur",
      "Thirukkuvalai",
      "Vedaranyam",
    ],
    Nilgiris: [
      "Udhagamandalam",
      "Coonoor",
      "Kothagiri",
      "Gudalur",
      "Pandalur",
    ],
    Namakkal: [
      "Namakkal",
      "Tiruchengode",
      "Rasipuram",
      "Kolli Hills",
      "Paramathi",
    ],
    Perambalur: ["Perambalur", "Kunnam", "Veppanthattai"],
    Pudukkottai: [
      "Pudukkottai",
      "Aranthangi",
      "Alangudi",
      "Iluppur",
      "Gandarvakottai",
      "Karambakudi",
      "Kulathur",
      "Ponnamaravathi",
      "Thirumayam",
    ],
    Ramanathapuram: [
      "Ramanathapuram",
      "Paramakudi",
      "Thiruvadanai",
      "Rameswaram",
      "Kadaladi",
      "Kamudi",
    ],
    Ranipet: [
      "Arakkonam",
      "Arcot",
      "Sholinghur",
      "Kalavai",
      "Walajah",
    ],
    Salem: [
      "Salem",
      "Attur",
      "Edappadi",
      "Gangavalli",
      "Mettur",
      "Omalur",
      "Sankari",
      "Yercaud",
    ],
    Sivaganga: [
      "Sivaganga",
      "Karaikudi",
      "Tirupathur",
      "Devakottai",
      "Manamadurai",
      "Ilayangudi",
    ],
    Tenkasi: [
      "Tenkasi",
      "Sankarankovil",
      "Shencottai",
      "Veerakeralampudur",
      "Alangulam",
    ],
    Tiruppur: [
      "Tiruppur",
      "Avinashi",
      "Palladam",
      "Kangayam",
      "Dharapuram",
      "Madathukulam",
    ],
    Tiruchirappalli: [
      "Lalgudi",
      "Manapparai",
      "Musiri",
      "Srirangam",
      "Thiruverumbur",
      "Thottiyam",
      "Tiruchirappalli",
    ],
    Theni: [
      "Theni",
      "Uthamapalayam",
      "Bodinayakanur",
      "Periyakulam",
      "Andipatti",
    ],
    Tirunelveli: [
      "Tirunelveli",
      "Palayamkottai",
      "Cheranmahadevi",
      "Ambasamudram",
      "Radhapuram",
      "Nanguneri",
    ],
    Thanjavur: [
      "Thanjavur",
      "Kumbakonam",
      "Papanasam",
      "Pattukkottai",
      "Peravurani",
      "Orathanadu",
    ],
    Thoothukudi: [
      "Thoothukudi",
      "Kovilpatti",
      "Ettayapuram",
      "Ottapidaram",
      "Srivaikuntam",
      "Tiruchendur",
      "Vilathikulam",
    ],
    Tirupattur: [
      "Tirupattur",
      "Ambur",
      "Vaniyambadi",
      "Jolarpet",
      "Natrampalli",
    ],
    Tiruvallur: [
      "Tiruvallur",
      "Ponneri",
      "Gummidipoondi",
      "Uthukkottai",
      "Poonamallee",
      "Avadi",
    ],
    Tiruvarur: [
      "Tiruvarur",
      "Nannilam",
      "Mannargudi",
      "Kodavasal",
      "Thiruthuraipoondi",
    ],
    Tiruvannamalai: [
      "Tiruvannamalai",
      "Arani",
      "Cheyyar",
      "Polur",
      "Vandavasi",
      "Chengam",
      "Kalayarkoil",
    ],
    Vellore: [
      "Vellore",
      "Katpadi",
      "Gudiyatham",
      "Anaicut",
      "K V Kuppam",
    ],
    Viluppuram: [
      "Villupuram",
      "Gingee",
      "Tindivanam",
      "Vanur",
      "Kallakurichi",
    ],
    Virudhunagar: [
      "Virudhunagar",
      "Aruppukottai",
      "Rajapalayam",
      "Sivakasi",
      "Sattur",
      "Srivilliputtur",
      "Vembakottai",
    ],
  };

  const aboutHouseOptions = ["Own House", "Rented House", "Govt Staff Quarters"];
  const typeOfHouseOptions = ["Ottu Veedu", "Tharsu Veedu", "Attai Veedu", "Maadi Veedu", "Atukku Maadi Veedu", "Apartment", "Other"];

  const [data, setData] = useState({
    aboutHouse: "",
    typeOfHouse: "",
    permanentAddress: "",
    state: "",
    district: "",
    taluk: "",
  });

  const inputStyle = {
    border: "1.5px solid #757575",
    borderRadius: "12px",
    boxShadow: "none",
    outline: "none",
    fontWeight: "bold",
    color: "#333",
  };

  const labelStyle = {
    color: "#212121",
    fontWeight: "800",
    marginBottom: "6px",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "state") {
      setData({
        ...data,
        state: value,
        district: "",
        taluk: "",
      });
    } else if (name === "district") {
      setData({
        ...data,
        district: value,
        taluk: "",
      });
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: Number(id),
      aboutHouse: data.aboutHouse,
      typeOfHouse: data.typeOfHouse,
      permanentAddress: data.permanentAddress,
      state: data.state,
      district: data.district,
      taluk: data.taluk,
    };

    api
      .post("/admin/userProfile/addressUpdate/", payload)
      .then(() => {
        Swal.fire("Success", "Address details updated", "success").then(() => {
          history.goBack();
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update address details", "error");
      });
  };

  useEffect(() => {
    api
      .get(`/admin/userProfile/profileView?userId=${id}`)
      .then((res) => {
        const d = res.data && res.data.data ? res.data.data : {};
        const profile = d.profile || {};
        setData({
          aboutHouse: profile.aboutHouse || "",
          typeOfHouse: profile.typeOfHouse || "",
          permanentAddress: profile.permanentAddress || "",
          state: profile.state || "",
          district: profile.district || "",
          taluk: profile.taluk || "",
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load address details", "error");
      });
  }, [id]);

  return (
    <div style={{ background: "#fff", marginTop: "70px" }}>
      <div
        style={{
          color: "#1a237e",
          fontWeight: "900",
          padding: "20px 10px",
        }}
      >
        <h4 style={{ fontSize: "1.8rem" }}>Update Address Details</h4>
      </div>

      <Form
        onSubmit={handleSubmit}
        style={{ padding: 24, maxWidth: 1200, margin: "0 10px" }}
      >
        <FormGroup>
          <Label style={labelStyle}>About Your House</Label>
          <Input
            type="select"
            name="aboutHouse"
            value={data.aboutHouse}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select</option>
            {aboutHouseOptions.map((opt, index) => (
              <option key={index} value={opt}>
                {opt}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Type of House</Label>
          <Input
            type="select"
            name="typeOfHouse"
            value={data.typeOfHouse}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select</option>
            {typeOfHouseOptions.map((opt, index) => (
              <option key={index} value={opt}>
                {opt}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Permanent Address</Label>
          <Input
            type="textarea"
            name="permanentAddress"
            value={data.permanentAddress}
            onChange={handleChange}
            placeholder="Enter permanent address"
            rows={3}
            style={inputStyle}
          />
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>State</Label>
          <Input
            type="select"
            name="state"
            value={data.state}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="">Select State</option>
            {Object.keys(stateData).map((state, index) => (
              <option key={index} value={state}>
                {state}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>District</Label>
          <Input
            type="select"
            name="district"
            value={data.district}
            onChange={handleChange}
            disabled={!data.state}
            style={inputStyle}
          >
            <option value="">Select District</option>
            {data.state &&
              stateData[data.state] &&
              stateData[data.state].districts &&
              stateData[data.state].districts.map((district, index) => (
                <option key={index} value={district}>
                  {district}
                </option>
              ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <Label style={labelStyle}>Taluk</Label>
          <Input
            type="select"
            name="taluk"
            value={data.taluk}
            onChange={handleChange}
            disabled={!data.district}
            style={inputStyle}
          >
            <option value="">Select Taluk</option>
            {data.district &&
              talukData[data.district] &&
              talukData[data.district].map((taluk, index) => (
                <option key={index} value={taluk}>
                  {taluk}
                </option>
              ))}
          </Input>
        </FormGroup>

        <Button
          type="submit"
          style={{
            width: "30%",
            borderRadius: 8,
            backgroundColor: "#000",
            color: "#fff",
            fontWeight: "bold",
            padding: "10px 0",
          }}
        >
          Save & Continue
        </Button>
      </Form>
    </div>
  );
};

export default UpdateAddressDetails;
